import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const DRUM_TYPES = ['metal', 'plastic', 'wood'];

const defaultForm = {
  name: '',
  drumType: 'metal',
  drumDiameter: '',
  flangeWidth: '',
  barrelDiameter: '',
  maxWeight: '',
  active: true,
  notes: ''
};

const DrumFormModal = ({ show, onHide, drum, onSubmit, isLoading }) => {
  const isEdit = !!drum;
  const [form, setForm] = useState(defaultForm);

  useEffect(() => {
    if (drum) {
      setForm({
        name: drum.name || '',
        drumType: drum.drumType || 'metal',
        drumDiameter: drum.drumDiameter || '',
        flangeWidth: drum.flangeWidth || '',
        barrelDiameter: drum.barrelDiameter || '',
        maxWeight: drum.maxWeight || '',
        active: drum.active !== undefined ? drum.active : true,
        notes: drum.notes || ''
      });
    } else {
      setForm(defaultForm);
    }
  }, [drum, show]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    const payload = {
      ...form,
      drumDiameter: Number(form.drumDiameter),
      flangeWidth: Number(form.flangeWidth),
      barrelDiameter: Number(form.barrelDiameter),
      maxWeight: form.maxWeight ? Number(form.maxWeight) : undefined
    };
    if (isEdit) {
      onSubmit({ id: drum._id, ...payload });
    } else {
      onSubmit(payload);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? 'Edit Drum' : 'Add Drum'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Name (auto-generated if empty)</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="e.g. Metal 1250"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Drum Type *</Form.Label>
                <Form.Select
                  name="drumType"
                  value={form.drumType}
                  onChange={handleChange}
                  required
                >
                  {DRUM_TYPES.map(type => (
                    <option key={type} value={type}>
                      {type.charAt(0).toUpperCase() + type.slice(1)}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Drum Diameter (mm) *</Form.Label>
                <Form.Control
                  type="number"
                  name="drumDiameter"
                  value={form.drumDiameter}
                  onChange={handleChange}
                  required
                  placeholder="e.g. 1250"
                />
                <Form.Text className="text-muted">
                  Outer/flange diameter (D)
                </Form.Text>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Flange Width (mm) *</Form.Label>
                <Form.Control
                  type="number"
                  name="flangeWidth"
                  value={form.flangeWidth}
                  onChange={handleChange}
                  required
                  placeholder="e.g. 800"
                />
                <Form.Text className="text-muted">
                  Winding width (B)
                </Form.Text>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Barrel Diameter (mm) *</Form.Label>
                <Form.Control
                  type="number"
                  name="barrelDiameter"
                  value={form.barrelDiameter}
                  onChange={handleChange}
                  required
                  placeholder="e.g. 630"
                />
                <Form.Text className="text-muted">
                  Core diameter (d)
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Max Weight (kg)</Form.Label>
                <Form.Control
                  type="number"
                  name="maxWeight"
                  value={form.maxWeight}
                  onChange={handleChange}
                  placeholder="Optional"
                />
              </Form.Group>
            </Col>
            {isEdit && (
              <Col md={4} className="d-flex align-items-end">
                <Form.Check
                  type="switch"
                  id="drum-active-switch"
                  label="Active"
                  checked={form.active}
                  onChange={e =>
                    setForm(prev => ({ ...prev, active: e.target.checked }))
                  }
                />
              </Col>
            )}
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              name="notes"
              value={form.notes}
              onChange={handleChange}
              placeholder="Additional notes (optional)"
              maxLength={500}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={isLoading}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={isLoading}>
            {isLoading ? 'Saving...' : isEdit ? 'Save' : 'Add'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default DrumFormModal;
